module.exports = __webpack_public_path__ + "static/media/frames-walls-colored.fb67bef0.png";